import type { PrivacyContent } from "./types";

export const privacyZh: PrivacyContent = {
  locale: "zh",
  seo: {
    title: "隐私政策 - Prismark",
    description: "Prismark 隐私政策，说明相机、麦克风、相册等权限的使用方式及数据处理说明。"
  },
  title: "隐私政策",
  updated: "最后更新：2026-09-13",
  intro: "Prismark 尊重你的隐私。本隐私政策说明你在使用 Prismark 时，应用如何处理相关信息。",
  sections: [
    {
      title: "1. 我们收集的信息",
      body: ["Prismark 不会收集、存储或上传你的照片和视频。本应用在设备本地提供拍照、视频录制、双摄录制与相册回看等功能，支持手动参数控制和实时曝光工具。"]
    },
    {
      title: "2. 相机、麦克风与相册权限",
      body: ["Prismark 可能会请求访问相机，用于拍摄照片和录制视频。麦克风权限仅用于录制带声音的视频。相册权限仅用于保存、查看或回看你通过应用创建的媒体内容。"]
    },
    {
      title: "3. 位置信息与照片元数据",
      body: [
        "Prismark 提供可选功能，可在拍摄照片的元数据中记录位置信息。该功能默认关闭，只有你主动在应用设置中开启后才会生效。",
        "开启后，Prismark 可能会请求访问设备的定位服务以获取当前地理位置坐标。该位置数据将直接嵌入到新拍摄照片的元数据（EXIF）中，并与照片一同保存在你的设备本地。",
        "位置信息仅用于嵌入到你的照片里。Prismark 不会收集、上传或与任何服务器或第三方分享你的位置数据。你可以随时在应用设置中关闭该功能；关闭后，新拍摄的照片将不再包含位置元数据，但不会影响你已经拍摄的照片中的位置数据。"
      ]
    },
    {
      title: "4. 照片和视频",
      body: ["你的照片和视频会保留在你的设备上，除非你主动通过系统分享或导出功能进行操作。Prismark 不会将你的媒体内容上传到我们的服务器。"]
    },
    {
      title: "5. 本地数据存储",
      body: [
        "Prismark 可能会在你的设备本地保存应用设置或偏好，以改善使用体验。这些设置不会用于识别你的身份。",
        "如果你导入了自己的 LUT 文件，Prismark 会在设备本地的应用存储空间里保留一份副本，以便将它应用到取景器画面以及你拍摄的照片和视频上。这些文件只存在你的设备上，不会上传到任何地方；你在应用内删除该 LUT 或删除应用时，它们会一并移除。",
        "你可以通过从设备中删除本应用来移除本地保存的应用数据。如果你就隐私或数据删除事项联系我们，我们会根据合理可获得的信息处理相关请求。"
      ]
    },
    {
      title: "6. 儿童隐私",
      body: ["Prismark 不会有意收集儿童的个人信息。"]
    },
    {
      title: "7. 政策更新",
      body: ["我们可能会不时更新本隐私政策。任何变更都会发布在本页面，并更新最后更新时间。"]
    },
    {
      title: "8. 联系我们",
      body: ["如果你对本隐私政策有任何疑问，请通过以下方式联系我们：", "axqora@gmail.com"]
    }
  ],
  termsLink: {
    body: "关于 Prismark 的使用规则，请阅读我们的用户协议。",
    label: "用户协议",
    href: "/zh/terms"
  }
};
